import { useApiQueries } from '../use-api.js';
import { annotationRangeChunks, mergeAnnotationPages, type Annotation } from './annotations.js';

/**
 * Annotations for a date window. Resolves to [] while loading or on error:
 * markers are context for a chart, and a failed annotations read must never
 * take the chart down with it.
 *
 * GET /api/annotations caps one request's span (MAX_RANGE_DAYS), and the
 * slicing page's since-2026-01-01 window outgrows it, so a long window is
 * fetched as consecutive chunks and merged. A chunk that fails or is still
 * loading just contributes nothing.
 */
export function useAnnotations(from: string | undefined, to: string | undefined): Annotation[] {
  const enabled = !!from && !!to;
  const chunks = enabled ? annotationRangeChunks(from, to) : [];
  const results = useApiQueries<{ annotations: Annotation[] }>(
    chunks.map(([f, t]) => ({ key: ['annotations', f, t], path: `/api/annotations?from=${f}&to=${t}` })),
    { enabled },
  );
  return enabled ? mergeAnnotationPages(results.map(r => r.data?.annotations ?? [])) : [];
}
